module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/mixed_desktop1-7dd25654d79dc7549d8ca92cecd28446.jpg";